import { App } from "@/app";
import { Transition as BaseTransition } from "@unseenco/taxi";
import gsap from "@lib/gsap";

// Set to true to enable debug logging for page transitions
const DEBUG = false;

const PRELOADER_SELECTOR = "[data-preloader]";

function getPreloader(scope: Document | Element = document): HTMLElement | null {
  return scope.querySelector(PRELOADER_SELECTOR);
}

/* -- Baseline Transition */
export class Transition extends BaseTransition {
  async onLeave({
    from,
    trigger,
    done,
  }: {
    from: Element | HTMLElement;
    trigger: string | false | HTMLElement;
    done: Function;
  }) {
    if (DEBUG) console.log("[Transition] onLeave - animating out");

    const preloader = getPreloader(from) ?? getPreloader();
    if (preloader) {
      // Preloader einblenden (Overlay über alter Seite)
      await gsap.to(preloader, {
        opacity: 1,
        duration: 0.5,
        ease: "power2.inOut",
      });
    } else {
      await gsap.to(from, {
        opacity: 0,
        duration: 0.5,
        ease: "power2.inOut",
      });
    }

    await App.pages.transitionOut({
      from,
      trigger: trigger && typeof trigger !== "string" ? (trigger as HTMLAnchorElement) : undefined,
    });
    done();
  }

  async onEnter({
    to,
    trigger,
    done,
  }: {
    to: Element | HTMLElement;
    trigger: string | false | HTMLElement;
    done: Function;
  }) {
    if (DEBUG) console.log("[Transition] onEnter - animating in");

    const preloader = getPreloader(to) ?? getPreloader();
    if (preloader) {
      gsap.set(preloader, { opacity: 1 });
      await App.pages.transitionIn({
        to,
        trigger: trigger && typeof trigger !== "string" ? (trigger as HTMLAnchorElement) : undefined,
      });
      // Preloader ausblenden, neue Seite wird sichtbar
      await gsap.to(preloader, {
        delay: 0.5,
        opacity: 0,
        duration: 1,
        ease: "power2.inOut",
      });
    } else {
      gsap.set(to, { opacity: 0 });
      await App.pages.transitionIn({
        to,
        trigger: trigger && typeof trigger !== "string" ? (trigger as HTMLAnchorElement) : undefined,
      });
      await gsap.to(to, {
        opacity: 1,
        duration: 1,
        ease: "power2.inOut",
      });
    }

    done();
  }
}

/* -- ... Transition */
